import { MODAL_AUTH } from '@components/App/Modal/constants'
import type { AnyAction } from '@reduxjs/toolkit'
import { call } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

// openModal(modalType) puts the type straight into payload; openModal(type,
// props) wraps it as { modalType, modalProps }. Cover both shapes.
const getModalType = (payload: string | { modalType: string }): string =>
  typeof payload === 'string' ? payload : payload.modalType

export function* authModalOpen({ payload }: AnyAction) {
  if (getModalType(payload) === MODAL_AUTH) {
    yield call(sendGtmEvent, GtmTriggerName.AUTH_MODAL_OPEN, 'Auth modal shown')
  }
}
